import React, { useEffect } from 'react';
import { initMetaPixel, trackPixelEvent } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2whx95n6vnccj">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-green/85 md:text-3xl" data-id="element-1" data-mp="28te2fc3h77mk">
      🌸 Tu próxima consulta empieza con criterio, no con dudas.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPixelEvent('ViewContent', {
      content_name: 'Botiquín Bach Completo',
      content_type: 'product',
      value: 24990,
      currency: 'ARS'
    });
  }, []);
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-sageMist selection:text-brand-green" data-id="element-2" data-mp="3reltgdimfc74">
      <UrgencyBanner data-id="element-3" data-mp="2zlv66six0xu0" />
      <main data-id="element-4" data-mp="2zmenq84nlk7i">
        <Hero data-id="element-5" data-mp="2zmwif0bo3qdb" />
        <PackContents data-id="element-6" data-mp="2zn6cp03qwjot" />
        <InitialTestimonials data-id="element-7" data-mp="33mf25srr5vek" />
        <PainPoints data-id="element-8" data-mp="33nq4rp9gox43" />
        <LaunchOffer data-id="element-9" data-mp="33n6wz1dizp3s" />
        <MoreTestimonials data-id="element-10" data-mp="33oi3h8ycvayl" />
        <FAQ data-id="element-11" data-mp="38l8hzruihyhw" />
        <CostComparison data-id="element-12" data-mp="38li77d7qg1mj" />
        <TransitionPhrase data-id="element-13" data-mp="38k6uup081ljt" />
        <EmotionalClose data-id="element-14" data-mp="38o4h3ji3it7x" />
      </main>
      <Footer data-id="element-15" data-mp="3dl4n5uey3vz1" />
      <FloatingNotification data-id="element-16" data-mp="3dlwa6guh8ldp" />
    </div>;
}